import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import SuiviConsoOutput from './models/SuiviConsoOutput'
import { Chart } from 'chart.js'
import globalMixin from '../globalMixin'
import _ from 'lodash'
import Vue from 'vue'

export default mixins(routeMixin, globalMixin).extend({
    data() {
        return {
            companyName: '',
            suiviConso: null as null | SuiviConsoOutput,
            codeFamilleSelectionne: '',
            chart: null as null | Chart<'doughnut', number[], string>,
            dateDebut: new Date().getFullYear() + '-01-01',
            dateFin: '',
            menuDateDebut: '',
            menuDateFin: '',
            chirurgienFiltre: '',
            nomsChirurgienSelectList: [] as { text: string; value: string }[]
        }
    },
    methods: {
        formatDate(date: string) {
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        loadSuiviCA() {
            this.suiviConso = null
            this.codeFamilleSelectionne = ''

            if (!this.companyName) {
                return null
            }

            this.$loader.go()

            return this.$http
                .api(`suiviConso?name=${this.companyName}&dateDebut=${this.dateDebutFormatee}&dateFin=${this.dateFinFormatee}&codeChirurgien=${this.chirurgienFiltre || ''}`)
                .get()
                .then(x => {
                    this.suiviConso = x.data

                    // this.$swal.toast.success()
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        }
    },
    computed: {
        dateDebutFormatee: {
            get: function(): string {
                if (!this.dateDebut) return ''
                return this.formatDate(this.dateDebut)
            },
            set: function(value: string): void {
                this.dateDebut = value
            }
        },
        dateFinFormatee: {
            get: function(): string {
                if (!this.dateFin) return ''
                return this.formatDate(this.dateFin)
            },
            set: function(value: string): void {
                this.dateFin = value
            }
        }
    },
    watch: {
        // On passe par un watcher au lieu d'un computed car on souhaite trigger le changement de liste seulement quand on a pas de filtre chirurgien
        // Dans le cas où on a un filtre chirurgien, il disparait visuellement au rechargement de la liste
        suiviConso: function() {
            if (this.chirurgienFiltre) return
            if (!this.suiviConso) return

            this.nomsChirurgienSelectList = _.map(this.suiviConso.nomsChirurgiens, a => {
                return {
                    text: a,
                    value: a
                }
            })
        }
    }
})
